import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/challengerConversionSaga";
import { useDispatch, useSelector } from "react-redux";
import OffersFitter from "./smartComponents/OffersFitter";
import CustomDateRanges from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import FunnelChart from "./smartComponents/FunnelChart";
import NoData from "../../../components/noData/noData";

const ChallengerConversionModule = (props) => {
  const {
    isChartLoading,
    filtersDirty,
    datesDirty,
    isLoading,
    initialRequest,
    selectedRequestDates,
    error
  } = useSelector((state) => state.challengerConversion);
  const dispatch = useDispatch();

  const updateData = () => {
    if (filtersDirty && !datesDirty) {
      dispatch(actionCreators.fetchCurrentUser({ ...props, updateOnlyChart: true }));
    } else if (datesDirty) {
      dispatch(actionCreators.fetchDataAndFilters());
    }
  };
  const resetData = () => {
    dispatch(actionCreators.fetchCurrentUser({ ...props }));
  };

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser({ ...props }));
    }
  }, []);

  const content = () => {
    return (
      <>
        <div className="edit-selections-bar">
          <div className="select-box">
            <p className="offers-title">Challengers (Select 6 Max)</p>
            <OffersFitter />
          </div>

          <div className="select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>

          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>

          {filtersDirty ||
          (datesDirty &&
            !isLoading &&
            selectedRequestDates.startDate !== "Invalid Date" &&
            selectedRequestDates.endDate !== "Invalid Date") ? (
            <button className="submit" onClick={() => updateData()}>
              Update
            </button>
          ) : null}

          {filtersDirty || (datesDirty && !isLoading) ? (
            <button className="submit reset" onClick={() => resetData()}>
              Reset
            </button>
          ) : null}
        </div>

        {isChartLoading ? (
          <LoadingAnimation text="Getting fresh data, this may take a moment." />
        ) : (
          <div>{error ? <NoData size="medium" /> : <FunnelChart />}</div>
        )}
      </>
    );
  };
  return <SectionToggle isLoading={isLoading} title="Challenger Conversion" content={content()} />;
};

ChallengerConversionModule.propTypes = { params: PropTypes.object };

export default ChallengerConversionModule;
